export const TAGS = [
  { id: 'all',         label: 'All',           glow: 'gold' },
  { id: 'popular',     label: 'Popular',       glow: 'gold' },
  { id: 'topRated',    label: 'Highest Rated', glow: 'gold' },
  { id: 'newArrivals', label: 'New Arrivals',  glow: 'teal' },
  { id: 'fiction',     label: 'Fiction',      glow: 'purple' },
  { id: 'islam',       label: 'Islam',        glow: 'green' },
  { id: 'nonFiction',  label: 'Non-Fiction',  glow: 'blue' },
  { id: 'poems',       label: 'Poems',        glow: 'pink' },
  { id: 'history',     label: 'History',      glow: 'orange' },
];

export const CROC_COVER = '/uploads/books/crocodile/cover-en.png';

export const GLOW_PALETTE = ['green', 'purple', 'orange', 'blue', 'pink', 'teal', 'red', 'gold'];

export function makeCover(bgA, bgB, emoji) {
  const svg =
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 260'>` +
      `<defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>` +
        `<stop offset='0%' stop-color='${bgA}'/><stop offset='100%' stop-color='${bgB}'/>` +
      `</linearGradient></defs>` +
      `<rect width='200' height='260' fill='url(%23g)'/>` +
      `<text x='100' y='150' text-anchor='middle' font-size='110'>${emoji}</text>` +
    `</svg>`;
  return `data:image/svg+xml;utf8,${svg.replace(/#/g, '%23')}`;
}

export const SAMPLE_BOOKS = {
  newArrivals: [],
  fiction:     [],
  islam:       [],
  nonFiction:  [],
  poems:       [],
  history:     [],
};
